import Vue from "vue";
import Vuex from "vuex";
import storage from "store";

import favouritesStore from "./favouritesStore";
import createForumPostStore from "@/store/createForumPostStore";
import scenarioDirectoriesStore from "@/store/scenarioDirectoriesStore";
import licenseClaimStore from "@/store/licenseClaimStore";
import tmsStore from "@/store/tmsStore";
import { Distributors } from "@/utils/distributor.helper";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    appLoading: false,
    authed: false,
    userRole: {},
    user: {},
    isOnNative: false,
    deviceInfo: {
      hasInfo: false,
    },
    searchTerm: "",
    userJustVerified: false,
    currentDistributor: Distributors.none,
  },
  modules: {
    favouritesStore: favouritesStore,
    createForumPostStore: createForumPostStore,
    scenarioDirectoriesStore: scenarioDirectoriesStore,
    tmsStore: tmsStore,
    licenseClaimStore: licenseClaimStore,
  },
  mutations: {
    initialiseStore(state) {
      if (storage.get("store")) {
        this.replaceState(
          Object.assign(state, JSON.parse(storage.get("store")))
        );
      }
    },
    setAppLoading(state, appLoading) {
      state.appLoading = appLoading;
    },
    setAuthed(state, authed) {
      state.authed = authed;
    },
    setUserRole(state, userRole) {
      state.userRole = userRole;
    },
    setUser(state, user) {
      state.user = user;
    },
    setDeviceInfo(state, deviceInfo) {
      state.deviceInfo = deviceInfo;
      if (state.deviceInfo.device_id && state.deviceInfo.product) {
        state.deviceInfo.hasInfo = true;
      } else {
        state.deviceInfo.hasInfo = false;
      }
    },
    setIsOnNative(state, isOnNative) {
      state.isOnNative = isOnNative;
    },
    setSearchTerm(state, searchTerm) {
      state.searchTerm = searchTerm;
    },
    setUserJustVerified(state, newVal) {
      state.userJustVerified = newVal;
    },
    setDistributor(state, newVal) {
      state.currentDistributor = newVal;
    },
  },
  getters: {
    getAppLoading: (state) => {
      return state.appLoading;
    },
    getAuthed: (state) => {
      return state.authed;
    },
    getUserRole: (state) => {
      return state.userRole;
    },
    getUser: (state) => {
      return state.user;
    },
    getDeviceInfo: (state) => {
      return state.deviceInfo;
    },
    getIsOnNative: (state) => {
      return state.isOnNative;
    },
    getSearchTerm: (state) => {
      return state.searchTerm;
    },
    getUserJustVerified: (state) => {
      return state.userJustVerified;
    },
    getDistributor: (state) => {
      return state.currentDistributor;
    },
  },
});
store.subscribe((mutation, state) => {
  storage.set("store", JSON.stringify(state));
});
